import {Params} from '@feathersjs/feathers'

import {Country} from '../../types'

import * as feathersService from '../feathers'

export const COUNTRY = 'country'

export const get = async (params?: Params) => feathersService.find<Country>(COUNTRY, params)
